/**
 * Fan-out point between scan SOURCES and the screens listening for scans.
 *
 * Sources push codes in (today: the tablet app's plugin, device-bridge);
 * `useScannerInput` subscribes screens to it. Deliberately tiny — no Vue, no
 * state, so sources and tests can use it without a component context.
 */
type Listener = (code: string) => void

const listeners = new Set<Listener>()

export function subscribeScan(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function emitScan(code: string): void {
  // Copy first: a listener may unsubscribe (unmount) while being called.
  for (const listener of [...listeners]) listener(code)
}
